import React, { useEffect } from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import LandingPage from "@Screens/Register/LandingPage"
import { RegisterPage } from "@Screens/Register/RegisterPage"
import LoginStack from "../LoginStack/LoginStack"
import { ActivationCodePage } from "@Screens/Register/Activation"

const LandingPageStackNavigator = createNativeStackNavigator()

const RegisterLoginStack = ({ navigation }) => {
    useEffect(() => {
        const unsubscribe = navigation.addListener("focus", () => {})
        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe
    }, [navigation])

    return (
        <LandingPageStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            initialRouteName="LandingPage"
        >
            <LandingPageStackNavigator.Screen name="LandingPage" component={LandingPage} />
            <LandingPageStackNavigator.Screen name="LoginStack" component={LoginStack} />
            <LandingPageStackNavigator.Screen name="RegisterStack" component={RegisterPage} />
            <LandingPageStackNavigator.Screen name="Activation" component={ActivationCodePage} />
        </LandingPageStackNavigator.Navigator>
    )
}

export default RegisterLoginStack
